import { render, staticRenderFns } from "./newHome.vue?vue&type=template&id=1dd6b699&scoped=true&"
import script from "./newHome.vue?vue&type=script&lang=js&"
export * from "./newHome.vue?vue&type=script&lang=js&"
import style0 from "./newHome.vue?vue&type=style&index=0&lang=css&"
import style1 from "./newHome.vue?vue&type=style&index=1&id=1dd6b699&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd6b699",
  null
  
)

export default component.exports